import { auth as authApi } from './api';
import type { User } from './types';

type AuthChangeCallback = (user: User | null) => void;

let currentUser: User | null = null;
const listeners: AuthChangeCallback[] = [];

function notify(): void {
  listeners.forEach(cb => cb(currentUser));
}

export function onAuthChange(cb: AuthChangeCallback): void {
  listeners.push(cb);
}

export function getToken(): string | null {
  return localStorage.getItem('token');
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export function getCurrentUser(): User | null {
  return currentUser;
}

export async function login(username: string, password: string): Promise<User> {
  const { token, user } = await authApi.login(username, password);
  localStorage.setItem('token', token);
  currentUser = user;
  notify();
  return user;
}

export async function checkAuth(): Promise<boolean> {
  if (!getToken()) return false;
  try {
    currentUser = await authApi.me();
    notify();
    return true;
  } catch {
    localStorage.removeItem('token');
    currentUser = null;
    notify();
    return false;
  }
}

export function logout(): void {
  localStorage.removeItem('token');
  currentUser = null;
  notify();
  window.location.hash = '#/login';
}


